/**
 * The townsfolk's life on the HUD (lane C0-NPC): the minimap's ping for their trouble (N2, shared
 * systems/npcLifeEvents.ts: a pulsing red ring where someone is calling for help, until it is over) and the affinity
 * tier in the target frame's title (N3, data/npcAffinity.ts).
 */
import { affinityTierOf, npcLifeOf, type Entity, type World } from '@nine/shared';

/** A person's title with how close the player is to them (ความสนิทสนม), when they remember the player at all. */
export function lifeTitle(world: World, t: Entity): string {
  const tier = t.kind === 'npc' || t.kind === 'ambient' ? affinityTierOf(world, t) : null;
  return tier ? [t.title, `สนิทสนม: ${tier.name}`].filter(Boolean).join(' · ') : t.title;
}

export function drawLifePings(
  g: CanvasRenderingContext2D,
  world: World,
  at: (x: number, y: number) => readonly [number, number],
): void {
  const ev = npcLifeOf(world)?.events.active;
  if (!ev || ev.phase === 'over' || world.interiors.inside) return;
  const [x, y] = at(ev.x, ev.y);
  const S = g.canvas.width;
  // Off the minimap's edge: pinned to the rim, pointing the way.
  const cx = Math.max(3, Math.min(S - 4, x));
  const cy = Math.max(3, Math.min(S - 4, y));
  const pulse = (world.time * 2) % 1;
  const r = 2 + Math.round(pulse * 4);
  g.fillStyle = '#ff4a3a';
  g.fillRect(cx - 1, cy - 1, 3, 3);
  g.globalAlpha = 1 - pulse;
  g.strokeStyle = '#ff6a4a';
  g.lineWidth = 1;
  g.strokeRect(cx - r + 0.5, cy - r + 0.5, r * 2, r * 2);
  g.globalAlpha = 1;
}
